import React from 'react';
import Badge from '../atoms/Badge';
import Heading from '../atoms/Heading';
import Text from '../atoms/Text';

const SectionHeader = ({
  badge,
  title,
  subtitle,
  centered = true,
  className = ''
}) => {
  const alignmentClass = centered ? 'text-center' : '';

  return (
    <div className={`${alignmentClass} ${className}`}>
      {badge && (
        <Badge variant="secondary" size="medium" className="mb-4">
          {badge}
        </Badge>
      )}
      <Heading level={2} className="mb-4">
        {title}
      </Heading>
      {subtitle && (
        <Text size="lg">{subtitle}</Text>
      )}
    </div>
  );
};

export default SectionHeader;
